
import includes from 'lodash/includes';
import MapCommand from './MapCommand';

export default class MapCommandRedraw extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'REDRAW';
    }

    execute(olMap, params) {
        // ToDo: do it better
        let map = olMap.getMap();
        //map.updateSize();

        map.getLayers().forEach(layer => {
            let redrawLayer = layer.getVisible();
            if (params.layers) {
                redrawLayer = redrawLayer && includes(params.layers, layer.get('id'));
            }
            if (redrawLayer) {
                let source = layer.getSource();
                if (source.getParams) {
                    let params = source.getParams();
                    params.t = new Date().getMilliseconds();
                    source.updateParams(params);
                }
            }
        });
    }
}
